__turbopack_context__.v({
  "cardsContainer": "_8MZBoa_cardsContainer",
  "content": "_8MZBoa_content",
  "overlayGradient": "_8MZBoa_overlayGradient",
  "personaCard": "_8MZBoa_personaCard",
  "root": "_8MZBoa_root" + " " + __turbopack_context__.i(92740)["sectionPadding"],
  "smImgOfLeft": "_8MZBoa_smImgOfLeft",
  "textContent": "_8MZBoa_textContent",
});
